import { HomeOutlined, ProfileOutlined, ShopOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
import { useState } from "react";
import { Link } from "wouter";
import ProfileModal from "../components/profileModal";
import ChangeDealerCode from "../components/common/changeDealerCode";
import ShippingAddressesModal from "../components/shippingAddressesModal";

const { Title } = Typography;
const MyAccount = () => {
  const [isProfileModal, setIsProfileModal] = useState(false);
  const [isShippingAddressesModal, setIsShippingAddressesModal] =
    useState(false);
  return (
    <div className="bg-gray-50 rounded-lg m-4 p-4 shadow-lg sm:my-16 sm:pb-32">
      <div className="sm:flex justify-between items-center mb-5">
        <Title level={2}>My Account</Title>
        <ChangeDealerCode />
      </div>
      <div className="flex items-center justify-center gap-5 flex-wrap">
        <Button
          className="max-sm:w-full h-full sm:px-32 py-8 text-2xl border border-[#0474B8] rounded-lg text-[#0474B8] flex gap-2 items-center justify-center font-bold"
          onClick={() => setIsProfileModal(true)}
        >
          <ProfileOutlined /> My Profile
        </Button>
        <Link
          to="/orders"
          className="max-sm:w-full sm:px-32 py-8 text-2xl border border-[#0474B8] rounded-lg text-[#0474B8] flex gap-2 items-center justify-center font-bold"
        >
          <ShopOutlined /> My Orders
        </Link>
        <Button
          className="max-sm:w-full h-full sm:px-32 py-8 text-2xl border border-[#0474B8] rounded-lg text-[#0474B8] flex gap-2 items-center justify-center font-bold"
          onClick={() => setIsShippingAddressesModal(true)}
        >
          <HomeOutlined /> My Addresses
        </Button>
      </div>
      {isProfileModal && (
        <ProfileModal
          isProfileModal={isProfileModal}
          setIsProfileModal={setIsProfileModal}
        />
      )}
      {isShippingAddressesModal && (
        <ShippingAddressesModal
          isShippingAddressesModal={isShippingAddressesModal}
          setIsShippingAddressesModal={setIsShippingAddressesModal}
        />
      )}
    </div>
  );
};

export default MyAccount;
